import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton"]
  static values = {
    prixes: Object,
    payOneLabel: String,
    payManyLabel: String,
    validateLabel: String,
    currencySymbol: { type: String, default: "€" }
  }

  connect() {
    this.boundRecompute = () => this.recompute()
    this.element.addEventListener("change", this.boundRecompute)
    this.element.addEventListener("input", this.boundRecompute)
    this.element.addEventListener("$change", this.boundRecompute)
    this.recompute()
  }

  disconnect() {
    this.element.removeEventListener("change", this.boundRecompute)
    this.element.removeEventListener("input", this.boundRecompute)
    this.element.removeEventListener("$change", this.boundRecompute)
  }

  recompute() {
    const decisionInputs = this.element.querySelectorAll(
      'input[type="radio"][name^="subscription[applied_members_attributes]"][name$="[decision]"]'
    )
    const seenIdx = new Set()
    let totalCents = 0
    let selectedCount = 0

    decisionInputs.forEach((input) => {
      if (!input.checked) return
      const match = input.name.match(/\[applied_members_attributes\]\[(\d+)\]/)
      if (!match) return
      const idx = match[1]
      if (seenIdx.has(idx)) return
      seenIdx.add(idx)

      if (input.value === "true") {
        selectedCount += 1
        // Un participant porte deux listes de tarifs (plein / réduit "3ème jeune")
        // dont une seule est active : seule celle-ci compte dans le total.
        const prixSelect = this.element.querySelector(
          `select[name="subscription[applied_members_attributes][${idx}][prix_id]"]:not([disabled])`
        )
        if (prixSelect && prixSelect.value) {
          const cents = this.prixesValue[prixSelect.value] || 0
          totalCents += cents
        }
      }
    })

    const donInput = this.element.querySelector('input[name="subscription[don]"]')
    if (donInput && donInput.value) {
      const donValue = parseFloat(donInput.value.toString().replace(",", "."))
      if (!isNaN(donValue) && donValue > 0) {
        totalCents += Math.round(donValue * 100)
      }
    }

    this.updateLabel(totalCents, selectedCount)
  }

  updateLabel(totalCents, selectedCount) {
    if (!this.hasSubmitButtonTarget) return

    let nextLabel
    if (totalCents <= 0) {
      nextLabel = this.validateLabelValue
    } else {
      const amountStr = this.formatAmount(totalCents)
      const template = selectedCount > 1 ? this.payManyLabelValue : this.payOneLabelValue
      nextLabel = template.replace("%{amount}", amountStr)
    }

    if (this.submitButtonTarget.tagName === "INPUT") {
      this.submitButtonTarget.value = nextLabel
    } else {
      this.submitButtonTarget.textContent = nextLabel
    }
  }

  formatAmount(cents) {
    const euros = cents / 100
    const symbol = this.currencySymbolValue
    if (Number.isInteger(euros)) {
      return `${euros} ${symbol}`
    }
    return `${euros.toFixed(2).replace(".", ",")} ${symbol}`
  }
}
